import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { heading1Obj, textXSObj, textLObj } = typographyStyles;
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { Breakpoints } = constants.breakpoints;

export const mainContainerCss = {
  display: "flex",
  zIndex: 1,
  // Workaround until GlobalLayout footer gets fixed.
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    marginBottom: "80px",
  },
};

export const containerCss = {
  padding: "1.5rem 2.5rem",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: "1rem",
  },
};

export const containerPaddingTopModifierCss = {
  padding: "0 2.5rem 2rem",
};

export const contentContainerCss = {
  flexGrow: 1,
  width: "calc(100% - 14.4375rem)",
  [breakpoint.between(Breakpoints.sm, Breakpoints.md)]: {
    width: "calc(100% - 11.625rem)",
  },
  [breakpoint.upTo(Breakpoints.sm)]: {
    width: "100%",
  },
};

export const separatorCss = {
  content: '""',
  background: ui.neutral[100],
  display: "block",
  height: "1px",
  margin: "0 auto",
  width: "calc(100% - 5rem)",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    width: "calc(100% - 2rem)",
  },
};

export const alertContainerCss = {
  padding: "1.75rem 2.5rem 0 2.5rem",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: "1rem",
    paddingBottom: 0,
  },
};

export const headerContainerCss = {
  padding: "1.75rem 2.5rem 1.5rem 2.5rem",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: "1rem",
  },
};

export const headerWithDividerContainerCss = [
  headerContainerCss,
  {
    borderBottom: "1px solid",
    borderColor: ui.neutral[100],
  },
];

export const headerCss = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    flexFlow: "column",
    alignItems: "flex-start",
  },
};

export const titleCss = [
  heading1Obj,
  {
    flexGrow: 1,
    margin: 0,
    lineHeight: "3rem",
    fontFamily: "Noto Serif",
    color: ui.neutral[700],
    maxWidth: "800px",
    [breakpoint.upTo("sm")]: {
      fontSize: "1.625rem",
      lineHeight: "2rem",
    },
  },
];

export const descriptionAndMessagesContainerCss = {
  position: "relative",
};

export const breadcrumbsCss = [
  {
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      marginBottom: 12,
    },
  },
  textXSObj,
  {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    "li > div > div": {
      zIndex: "1000",
    },
  },
  {
    '[aria-current="page"]': {
      textDecoration: "none",
    },
    "li:first-of-type > a": {
      textDecoration: "none",
    },
  },
];

export const descriptionPageCss = [
  textLObj,
  {
    margin: "0",
    marginTop: "8px",
  },
  {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
      flexFlow: "column",
      alignItems: "flex-start",
    },
  },
];

export const statusContainerCss = {
  marginBottom: 8,
};
